export const allOptionId = "all";
export const allOptionName = "All";
export const allOption = { id: allOptionId, name: allOptionName };
export const CUSTOM = "Custom";
export const LAST_MONTH = "Last Month";
export const LAST_2_MONTHS = "Last 2 Months";
export const LAST_3_MONTHS = "Last 3 Months";
export const LAST_6_MONTHS = "Last 6 Months";
export const LAST_12_MONTHS = "Last 12 Months";
export const LAST_YEAR = "Last Year";
export const THIS_YEAR = "This Year";
export const THIS_MONTH = "This Month";
export const LAST_7_DAYS = "Last 7 Days";
export const YESTERDAY = "Yesterday";
export const TODAY = "Today";
export const CREATE = "create";
export const UPDATE = "update";
export const REQUEST_TYPES = ["Email", "My Access"];
export const DENOMINATOR_AGGREGATION = "HR-D";
export const NUMERATOR_AGGREGATION = "HR-N";
export const HR_NUMERATOR = "HR Numerator";
export const HR_DENOMINATOR = "HR Denominator";
export const HR_PERCENT = "HR Percent";
export const HR = "HR";
export const GLOBAL_HR = "GlobalHR";
export const UP100 = "UP100";
export const ADVANCED_NII = "AdvancedNII";
export const DV100 = "DV100";
export const GLOBAL_DV100 = "GlobalDV100";
export const BALANCE = "Balance";
export const BSLR = "BSLR";
export const STDTDR = "STDTDR";
export const LTDC = "LTDC";
export const TOTAL_LT_DEBT = "Total LT Debt";
export const TOTAL_LT_DEBT_AGGREGATION = "TOTAL-LT-DEBT";
export const CONCENTRATION = "Concentration";
export const LATEST_ANNUAL_NII_FORECAST_ACCOUNT_NAME =
  "Latest Annual NII Forecast";
export const EVE_BASE_ACCOUNT_NAME = "EVEBase";
export const GLOBAL = "global";
export const TFSB = "TFSB";

export const GOOGLE_NEWS_SEARCH_QUERY1 = "Business";
export const GOOGLE_NEWS_SEARCH_QUERY2 = "Toyota";

export const CONSOLIDATED_ENTITY = "Consolidated";
export const LOCAL_CURRENCY = "Local";
export const REPORTING_CURRENCY = "Reporting";
export const CURRENCY_LIST = [LOCAL_CURRENCY, REPORTING_CURRENCY];

export const ADVANCED_NII_ACCOUNT_NAMES = {
  TOTAL_RECEIVABLES: "Total Receivables",
  TOTAL_PAYABLES: "Total Payables",
  LATEST_ANNUAL_NII_FORECAST: "Latest Annual NII Forecast",
};
export const ADVANCED_NII_PROPERTY_TYPES = {
  BALANCE: "Balance",
  NII_BASE: "NiiBase",
  NII_SENSITIVITY: "NiiSensitivity",
  NII_UP100: "NiiUP100",
};

export const TWELVE_MOHTHS_EARNING_AT_RISK = "12mths Earnings at Risk";
export const LATEST_ANNUAL_NII_FORECAST = "Latest Annual NII Forecast (Plan)";
export const HUNDRED_BP_PARALLEL_SHIFT = "100bp Parallel Shift (% Profit)";

export const ADVANCED_NII_TAB_CONFIG = [
  {
    label: "NII SENSITIVITY DETAIL",
    propertyType: ADVANCED_NII_PROPERTY_TYPES.NII_SENSITIVITY,
    summaryLabel: "Total Income Sensitivity",
  },
  {
    label: "NII BASE INC EXP",
    propertyType: ADVANCED_NII_PROPERTY_TYPES.NII_BASE,
    summaryLabel: "Total NII Base",
  },
  {
    label: "NII UP100 INC EXP",
    propertyType: ADVANCED_NII_PROPERTY_TYPES.NII_UP100,
    summaryLabel: "Total NII UP100",
  },
  {
    label: "BALANCE BASE",
    propertyType: ADVANCED_NII_PROPERTY_TYPES.BALANCE,
    summaryLabel: "Total Balance Base",
  },
];

export const FILE_TYPES = {
  TFA_DISCOUNT_RATES_FILE: "TFA_DISCOUNT_RATES_FILE",
  GLOBAL_ALM_MODELS_FILE: "GLOBAL_ALM_MODELS_FILE",
  EXOGENEOUS_INPUTS_FILE: "EXOGENEOUS_INPUTS_FILE",
  EMPYREAN_OP_DB_FILE: "EMPYREAN_OP_DB_FILE",
  MODEL_ENTITY_OP_FILE: "MODEL_ENTITY_OP_FILE",
  APPROVAL_FLOW_STEPS_FILE: "APPROVAL_FLOW_STEPS_FILE",
  MULTILEDGER_FX_FILE: "MULTILEDGER_FX_FILE",
  SFTP_FILE_PREFIX_FILE: "SFTP_FILE_PREFIX_FILE",
  // TREASURY_GUIDELINES_FILE: "TREASURY_GUIDELINES_FILE",
};

export const CHECK_IN = "CHECK_IN";
export const CHECK_OUT = "CHECK_OUT ";

export const VIEWTYPE = {
  LOCAL: "Local",
  GLOBAL: "Global",
};

export const DIMENSION = {
  INTEREST_RATE_RISK: "Interest Rate Risk",
  LIQUIDITY_RISK: "Liquidity Risk",
  COUNTERPARTY_CREDIT_RISK: "Counterparty Credit Risk",
};

export const DIMENSION2 = {
  DERIVATIVES: "Derivatives",
  LIQUID_DEPOSITS_AND_INVESTMENTS: "Liquid Deposits & Investments",
};

export const MEASURE = {
  SQUARE_HEDGE_RATIO_KRI: "Square Hedge Ratio [KRI]",
  DV100_INTEREST_RATE_SENSITIVITY_EQUITY_PERCENTAGE:
    "DV100 Interest Rate Sensitivity (in % equity)",
  HUNDRED_BP_PARALLEL_SHIFT_KRI: "100bp Parallel Shift [KRI]",
  OPTION_WRITING_OR_SELLING: "Option Writing/Selling",
  STRUCTURED_DEBT_PRODUCTS: "Structured Debt Products",
  FX_RISK: "FX Risk",
  DAYS_UNTIL_ALTERNATIVE_FUNDING_2_KRI:
    "Days Until Alternative Funding 2 [KRI]",
  BALANCE_SHEET_LIQUIDITY_RATIO_KRI: "Balance Sheet Liquidity Ratio [KRI]",
  SHORT_TERM_DEBT_TO_TOTAL_DEBT_RATIO: "Short-term Debt to Total Debt Ratio",
  FUNDING_CONCENTRATION: "Funding Concentration",
  BANK_LINE_UTILIZATION_RATIO: "Bank Line Utilization Ratio",
  MONTHLY_LONG_TERM_DEBT_MATURITY_CONCENTRATION:
    "Monthly Long-term Debt Maturity Concentration",
  MINIMUM_CREDIT_RATING_GREATERTHAN_5_AND_LESSTHANEQUALTO_10_YEARS:
    "Minimum Credit Rating for transactions with tenor of > 5 years and <= 10 years",
  MINIMUM_CREDIT_RATING_LESSTHANEQUALTO_5_YEARS:
    "Minimum Credit Rating for transactions with tenor of <= 5 years",
  CREDTIT_EXPOSURE_A_OR_A2:
    "Credit Exposure (in % total asset) to one Counterparty with a minimum credit rating of A / A2",
  CREDTIT_EXPOSURE_BBB_PLUS_OR_BAA_ONE:
    "Credit Exposure (in % total asset) to one Counterparty with a minimum credit rating of BBB+ / Baa1",
  CREDTIT_EXPOSURE_CENTRALIZED:
    "Credit Exposure (in % total asset) to one Counterparty with a minimum credit rating of Lower or non-rated, collateralized",
  CREDTIT_EXPOSURE_OTHERS:
    "Credit Exposure (in % total asset) to one Counterparty with a minimum credit rating of Lower or non-rated, others",
  CREDTIT_EXPOSURE_AA_MINUS_OR_AA3_OR_A1PLUS:
    "Credit Exposure (in % total asset) [KRI] to one Counterparty with a minimum credit rating of AA- / Aa3  or  A-1+",
  CREDTIT_EXPOSURE_A_OR_A2_OR_A1_OR_P1:
    "Credit Exposure (in % total asset) [KRI] to one Counterparty with a minimum credit rating of A / A2  or  A-1 / P-1",
  CREDTIT_EXPOSURE_SETTLEMENT_BANKS:
    "Credit Exposure (in % total asset) [KRI] to one Counterparty with a minimum credit rating of Lower or non-rated settlement banks   ",
  CREDTIT_EXPOSURE_NON_SETTLEMENT_BANKS:
    "Credit Exposure (in % total asset) [KRI] to one Counterparty with a minimum credit rating of Lower or non-rated non-settlement banks",
  HR_NUMERATOR: "HR Numerator",
  HR_DENOMINATOR: "HR Denominator",
  TWELVE_MONTHS_EARNINGS_AT_RISK: "12 months earnings at risk",
  LATEST_ANNUAL_NII_FORECAST: "Latest Annual NII Forecast",
  SHORT_TERM_ASSETS_12_MONTHS: "Short Term Assets (12 months)",
  SHORT_TERM_LIABILITIES_12_MONTHS: "Short Term Liabilities (12 months)",
  SHORT_TERM_LIABILITIES_LESS_THAN_12_MONTHS:
    "Short Term Liabilities (<=12 months)",
  TOTAL_DEBT: "Total Debt",
  HIGHEST_CONCENTRATION_MONTH: "Highest Concentration Month",
};

export const MARKETVALUE = {
  TOTAL_ASSETS: "Total Assets",
  TOTAL_LIABILITIES: "Total Liabilities",
  TOTAL_EQUITY: "Total Equity",
  OFF_BALANCE_SHEET: "Off Balance Sheet",
  AUXILLIARY: "Auxilliary",
  NET_EQUITY: "Net Equity",
};

export const GLOBALMARKETVALUE = {
  GLOBAL_TOTAL_ASSETS: "Global Total Assets",
  GLOBAL_TOTAL_LIABILITIES: "Global Total Liabilities",
  GLOBAL_TOTAL_EQUITY: "Global Total Equity",
  GLOBAL_OFF_BALANCE_SHEET: "Global Off Balance Sheet",
  GLOBAL_AUXILLIARY: "Global Auxilliary",
  GLOBAL_NET_EQUITY: "Global Net Equity",
};

export const BALSHEETLIQRATIO = {
  SHORT_TERM_ASSETS: "Short Term Assets",
  SHORT_TERM_LIABILITIES: "Short Term Liabilities",
};

export const SHORTTERMDEBTTOTALDEBTRATIO = {
  TOTAL_DEBT: "Total Debt",
  SHORT_TERM_DEBT: "Short-Term Debt",
};
